var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuotes = function SvgQuotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98964 24C1.40933 24 0.911917 23.7927 0.497409 23.3782C0.165803 22.9637 0 22.4663 0 21.886C0 21.3057 0.124352 20.6425 0.373057 19.8964L6.96373 2.8601C7.37824 1.86528 7.8342 1.16062 8.3316 0.746112C8.82901 0.248704 9.57513 0 10.5699 0H14.6736C15.3368 0 15.8756 0.248704 16.2902 0.746112C16.5389 1.07772 16.6632 1.49223 16.6632 1.98964C16.6632 2.23834 16.6218 2.48705 16.5389 2.73575L13.8031 20.3938C13.4715 22.7979 12.3109 24 10.3212 24H1.98964ZM21.886 24C21.3057 24 20.8083 23.7927 20.3938 23.3782C20.0622 22.9637 19.8964 22.4663 19.8964 21.886C19.8964 21.057 20.0207 20.3938 20.2694 19.8964L26.8601 2.8601C27.2746 1.86528 27.7306 1.16062 28.228 0.746112C28.7254 0.248704 29.4715 0 30.4663 0H34.5699C35.2332 0 35.772 0.248704 36.1865 0.746112C36.4352 1.07772 36.5596 1.49223 36.5596 1.98964C36.5596 2.23834 36.5181 2.48705 36.4352 2.73575L33.6995 20.3938C33.3679 22.7979 32.2072 24 30.2176 24H21.886Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotes.381935fa.svg";
export { ForwardRef as ReactComponent };